import { validateCPF } from './cpf_cnpj';

export default {
    validate(value) {
        const onlyNumbers = value.replace(/[^\d]+/g, '');
        if (onlyNumbers.length !== 11) {
            return false;
        }
        return validateCPF(onlyNumbers);
    },
}